var oldGetScript = __webpack_require__.u;
var oldLoadScript = __webpack_require__.e;
var queryMap = new Map();
var countMap = new Map();
var maxRetries = 7;
__webpack_require__.u = function (chunkId) {
  var result = oldGetScript(chunkId);
  return result + (queryMap.has(chunkId) ? '?' + queryMap.get(chunkId) : '');
};
__webpack_require__.e = function (chunkId) {
  var result = oldLoadScript(chunkId);
  return result.catch(function (error) {
    var retries = countMap.has(chunkId) ? countMap.get(chunkId) : 5;
    if (retries < 1) {
      var realSrc = oldGetScript(chunkId);
      error.message =
        'Loading chunk ' +
        chunkId +
        ' failed after 7 retries.\n(' +
        realSrc +
        ')';
      error.request = realSrc;
      throw error;
    }
    var retryAttempt = 7 - retries + 1;
    var retryAttemptString = '&retry-attempt=' + retryAttempt;
    var cacheBust = (function () {
      return '';
    })();
    +retryAttemptString;
    queryMap.set(chunkId, cacheBust);
    countMap.set(chunkId, retries - 1);
    return __webpack_require__.e(chunkId);
  });
};
